import { render, staticRenderFns } from "./PreparationsReportMailPopup.vue?vue&type=template&id=67a2e7b3&"
import script from "./PreparationsReportMailPopup.vue?vue&type=script&lang=js&"
export * from "./PreparationsReportMailPopup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports